/* One optional, audited accessory. Native product forms continue to own cart writes. */
(() => {
  if (window.av151AccessoryGuard) return;
  window.av151AccessoryGuard = true;
  const selector = '[data-av151-single-addon]';
  const bound = new WeakSet();
  let revision = 0, timer;
  const root = window.Shopify?.routes?.root || '/';
  const flatten = items => (items || []).flatMap(item => [item, ...flatten(item.item_components || item.components)]);
  const inCart = (cart, productId) => flatten(cart.items).some(item => String(item.product_id || item.product?.id) === String(productId));
  const readCart = async () => {
    const response = await fetch(root + 'cart.js', {cache:'no-store', headers:{Accept:'application/json'}});
    if (!response.ok) throw Error('Cart unavailable');
    return response.json();
  };
  const conceal = el => el.setAttribute('data-av151-guard-hidden','');
  const eligibleCard = el => [...el.querySelectorAll('[data-extras-kind]')].find(card => !card.hidden);
  async function sync() {
    const current = ++revision;
    const offers = [...document.querySelectorAll(selector)];
    offers.forEach(conceal);
    if (!offers.length) return;
    let cart;
    try { cart = await readCart(); } catch { return; }
    if (current !== revision) return;
    for (const el of offers) {
      const card = eligibleCard(el);
      if (!card || !el.dataset.addonProductId || inCart(cart, el.dataset.addonProductId)) continue;
      el.removeAttribute('data-av151-guard-hidden');
      if (bound.has(el)) continue;
      bound.add(el);
      el.addEventListener('submit', event => {
        // Keep the original submit event: the theme owns availability, price and cart handling.
        if (el.hasAttribute('data-av151-guard-hidden') || !eligibleCard(el)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }
  }
  const schedule = () => { document.querySelectorAll(selector).forEach(conceal); clearTimeout(timer); timer = setTimeout(sync, 120); };
  ['cart:change','cart:refresh','cart:updated','variant:add','variant:change','product:variant-change','shopify:section:load'].forEach(name => document.addEventListener(name,schedule));
  window.addEventListener('pageshow',schedule);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
  new MutationObserver(records => { if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches?.(selector)||node.querySelector?.(selector))))) schedule(); }).observe(document.querySelector('#main') || document.body,{childList:true,subtree:true});
  schedule();
})();
